'use client'

import { useEffect } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { trackCadastroConcluido } from '@/lib/analytics'

/**
 * Dispara `cadastro_concluido` (GA4) após OAuth Google criar conta.
 * O callback redireciona com `?cadastro=google` e este componente limpa a URL.
 */
export function CadastroConcluidoTracker() {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  useEffect(() => {
    const metodo = searchParams.get('cadastro')
    if (metodo !== 'google' && metodo !== 'email') return

    trackCadastroConcluido(metodo)

    const next = new URLSearchParams(searchParams.toString())
    next.delete('cadastro')
    const qs = next.toString()
    router.replace(qs ? `${pathname}?${qs}` : pathname, { scroll: false })
  }, [searchParams, pathname, router])

  return null
}
